import { useAuth } from "domain/authentication";
import { useNavigate } from "react-router-dom";
import { routes } from "router";
import { AccordionContainer } from "./accordion-container";
import { AccordionLink } from "./accordion-link";

export const MY_ACCOUNT_ACCORDION_KEY = "MY_ACCOUNT_ACCORDION_KEY";

export const MyAccountAccordion = () => {
  const { logOut, user } = useAuth();

  const navigate = useNavigate();

  const handleSignOut = () => {
    logOut();
  };

  return (
    <AccordionContainer accordionKey={MY_ACCOUNT_ACCORDION_KEY}>
      <div className="flex flex-column">
        {!user && (
          <AccordionLink onClick={() => navigate(routes.SIGNIN)}>
            Sign in
          </AccordionLink>
        )}
        {user && (
          <>
            <AccordionLink onClick={() => navigate(routes.DASHBOARD)}>
              Dashboard
            </AccordionLink>
            <AccordionLink onClick={handleSignOut}>Sign out</AccordionLink>
          </>
        )}
      </div>
    </AccordionContainer>
  );
};
